import { MobileHeader } from '@widgets/mobile-header'
import type { TabsProps } from 'antd'
import { Button, Tabs, theme, Typography } from 'antd'
import { Delete } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { AdvertisingPlatforms } from './advertising-platforms'
import { MainFormMobile } from './main-form.mobile'
import { OrdForm } from './ord-form'
const { Title, Text } = Typography

export const AddPartnerPage = () => {
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Настройки',
            children: <MainFormMobile />
        },
        {
            key: '2',
            label: 'Интернет ресурсы',
            children: <AdvertisingPlatforms />,
            disabled: true
        },
        {
            key: '3',
            label: 'ОРД',
            children: <OrdForm />,
            disabled: true
        }
    ]

    const navigate = useNavigate()

    const {
        token: { colorPrimary, colorBgContainer }
    } = theme.useToken()

    return (
        <>
            <MobileHeader
                title={'Новый партнер'}
                filter={
                    <Button type="text" onClick={() => navigate(-1)}>
                        <Delete color={colorPrimary} />
                    </Button>
                }
            />
            <div
                style={{
                    position: 'relative',
                    background: colorBgContainer,
                    padding: '20px 16px',
                    overflow: 'auto',
                    flexGrow: 1
                }}
            >
                <Tabs defaultActiveKey="1" items={items} />
            </div>
        </>
    )
}
